import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/**
 * Converts a given date string to UTC format and returns it as a string.
 *
 * @param date - The date string to be converted and formatted.
 * @returns The formatted date string in UTC.
 */
export const parseDateToUTC = (date: string | Date | number): string => {
  return dayjs(date).utc(true).startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
};
